var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.119 2.496c.463.341.561.993.219 1.456l-10 13.542a1.045 1.045 0 0 1-1.485.198l-5-3.959A1.041 1.041 0 1 1 3.147 12.1l4.155 3.29 9.36-12.675a1.04 1.04 0 0 1 1.457-.219",
    clipRule: "evenodd"
  })));
};
export default SvgCheck;